import { render } from "./Imprint.vue?vue&type=template&id=b958b234&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=ts"
export * from "./Imprint.vue?vue&type=script&lang=ts"

import "./Imprint.vue?vue&type=style&index=0&id=b958b234&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b958b234"

export default script